import axios from 'axios';
import React, {useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { decodeToken } from "react-jwt";
import { Box, Button,  Typography } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login';
import AppToastContainer from '../components/AppToastContainer';
import 'react-toastify/dist/ReactToastify.css';
import DrawerAppBar from '../components/Bar'
import { useNavigate } from 'react-router-dom';

function Activate() {
    const { t } = useTranslation()
    let { tokenId } = useParams();

    const [values, setValues] = useState({
        name: '',
        token: '',
    })

    useEffect(() => {
        if (!tokenId) return
        const decoded = decodeToken(tokenId)
        console.log(decoded, tokenId)
        if (decoded?.name) {
            setValues(v => ({ ...v, name: decoded.name, token: tokenId }))
        }
    }, [tokenId])

    const { name, token } = values
    const navigate = useNavigate()

    const clickSubmit = event => {
        event.preventDefault()

        axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API}/account-activation`,
            data: { token }
        })
        .then(response => {
            console.log('ACCOUNT ACTIVATION', response)
            setValues({
                ...values,
                show: false
            })
            toast.success(response.data.message)
            navigate('/access')
        })
        .catch(error => {
            console.log('ACCOUNT ACTIVATION ERROR', error.response.data.error);
            toast.error(error.response.data.error)
        })
    }  
  return (
    <div style={{margin:10}}>
    <DrawerAppBar />
    <AppToastContainer />
    
      <Box 
        display="flex"
        flexDirection={"column"}
        maxWidth={400}
        alignItems={"center"}
        justifyContent={"center"}
        margin={"auto"}
        marginTop={13}
        padding={3}
        borderRadius={5}
        sx={(theme) => ({
          backgroundColor: 'background.paper',
          boxShadow: theme.palette.mode === 'dark'
            ? '5px 5px 14px rgba(0,0,0,0.6)'
            : '5px 5px 10px #ccc',
          ":hover": {
            boxShadow: theme.palette.mode === 'dark'
              ? '10px 10px 24px rgba(0,0,0,0.7)'
              : '10px 10px 20px #ccc'
          }
        })}
      >
        <Typography variant='p' component="h1" padding={3} textAlign={"center"}>
            {t('auth.activateTitle', { name })}
        </Typography>
            
        <Button onClick={clickSubmit} endIcon={<LoginIcon/>} sx={{marginTop: 3, borderRadius: 3}} variant='contained' color='success'>{t('auth.activateButton')}</Button>
        
      </Box>
    
  </div>
  )
}

export default Activate